import React, { useState, useEffect, useRef } from "react";
import "./Pagination.scss";

const Pagination = ({ page, pageSize, total, onChange }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  const totalPages = Math.ceil(total / pageSize);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (totalPages <= 1) return null;

  const pages = [1];

  if (totalPages >= 2) {
    pages.push(2);
  }

  if (page > 2) {
    pages.push("left-dots");

    if (page !== totalPages) {
      pages.push(page);
    }
  }

  if (page < totalPages - 1 && totalPages > 3) {
    pages.push("right-dots");
  }

  if (totalPages > 2) {
    pages.push(totalPages);
  }

  return (
    <div className="pagination" ref={dropdownRef}>
      <button disabled={page === 1} onClick={() => onChange(page - 1)}>
        Prev
      </button>

      {pages.map((item, idx) => {
        if (item == "left-dots" || item == "right-dots") {
          return (
            <div key={`${item}-${idx}`}  className="cursor-pointer-box-container">
              <span
                className="cursor-pointer"
                onClick={() =>
                  setOpenDropdown(openDropdown === item ? null : item)
                }
              >
                ...
              </span>

              {openDropdown === item && (
                <div className="cursor-pointer-box">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (pageNum) => (
                      <div
                        key={pageNum}
                        className={`cursor-pointer-page-num ${
                          page === pageNum ? "active" : ""
                        }`}
                        onClick={() => {
                          onChange(pageNum);
                          setOpenDropdown(null);
                        }}
                      >
                      Page {pageNum}
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          );
        }

        return (
          <button
            key={item}
            className={`cursor-pointer-page-num ${page === item ? "active" : ""}`}
            onClick={() => onChange(item)}
          >
            {item}
          </button>
        );
      })}

      <button
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;